export default __webpack_public_path__ + "static/media/map.001a2c03.png";